import en from './en';
import es from './es';
import esES from './es-ES';

export default {
    en,
    es,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'es-ES': esES,
};
